<!--Modals-->
<ui-dialog
    #jobBoardSettingsBasicModal
    formDialog
    primaryButtonLabel="{{ 'save' | appTranslate }}"
    secondaryButtonLabel="{{ 'cancel' | appTranslate }}"
    size="small"
    header="{{
        !jobBoard?.companySlug
            ? 'applicant-tracker.setupJobBoardInformation'
            : ('applicant-tracker.editJobBoardInformation' | appTranslate)
    }}"
    [form]="jobBoardSettingsBasicForm.form"
    (primaryButtonPressed)="onSave(jobBoardSettingsBasicForm.form, 'basicInformation'); setJobBoardAddress()"
    [open]="isEditJobBoardModalOpen"
    (closing)="onCancel()"
>
    <app-job-board-settings-basic-information
        #jobBoardSettingsBasicForm
        [jobBoard]="jobBoard"
    ></app-job-board-settings-basic-information>
</ui-dialog>

<ui-dialog
    #jobBoardSettingsVisualsModal
    formDialog
    size="small"
    header="{{ 'applicant-tracker.editJobBoardTheme' | appTranslate }}"
    [form]="jobBoardSettingsVisualsForm.form"
    (primaryButtonPressed)="onSave(jobBoardSettingsVisualsForm.form, 'jobBoardVisuals')"
    primaryButtonLabel="{{ 'save' | appTranslate }}"
    secondaryButtonLabel="{{ 'cancel' | appTranslate }}"
    [open]="isEditBrandAssetsModalOpen"
    (closing)="onCancel()"
>
    <app-job-board-settings-visuals #jobBoardSettingsVisualsForm [jobBoard]="jobBoard"></app-job-board-settings-visuals>
</ui-dialog>

<ui-dialog
    #jobBoardSettingsAdvancedStylesModal
    formDialog
    size="small"
    header="{{ 'applicant-tracker.editAdvancedStyles' | appTranslate }}"
    [form]="jobBoardSettingsAdvancedStylesForm.form"
    (primaryButtonPressed)="onSave(jobBoardSettingsAdvancedStylesForm.form, 'jobAdvancedStyles')"
    primaryButtonLabel="{{ 'save' | appTranslate }}"
    secondaryButtonLabel="{{ 'cancel' | appTranslate }}"
    [open]="isEditAdvanceStylesModalOpen"
    (closing)="onCancel()"
>
    <app-job-board-settings-advanced-styles #jobBoardSettingsAdvancedStylesForm [jobBoard]="jobBoard">
    </app-job-board-settings-advanced-styles>
</ui-dialog>

<ui-dialog
    *ngIf="jobBoard?.companySlug"
    size="small"
    header="{{ 'applicant-tracker.embeddedJobBoard' | appTranslate }}"
    [open]="isEmbeddedJobBoardModalOpen"
    (closing)="onCancel()"
>
    <app-job-board-settings-embedded-information
        [companySlug]="jobBoard?.companySlug"
    ></app-job-board-settings-embedded-information>

    <ui-dialog-footer>
        <ui-button type="primary" (click)="onCancel()">{{ 'done' | appTranslate }} </ui-button>
    </ui-dialog-footer>
</ui-dialog>

<!--Body-->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ 'applicant-tracker.recruitingSettings' | appTranslate }}"
        [menuService]="recruitingModuleMenuService"
    ></app-header>

    <ui-banner *ngIf="!jobBoard?.companySlug" variant="danger" class="margin-bottom-3">
        <p>{{ 'applicant-tracker.pleaseSetUpYourJobBoardInformationInOrderToAccessTheOtherFeature' | appTranslate }}</p>
    </ui-banner>

    <div class="profile-layout reverse">
        <div class="profile-layout-content">
            <ui-card>
                <app-segment-header
                    title="{{ 'applicant-tracker.jobBoardInformation' }}"
                    (edit)="openEditJobBoard()"
                    editLabel="{{ !jobBoard?.companySlug ? 'setUp' : ('edit' | appTranslate) }}"
                ></app-segment-header>

                <div class="app-grid">
                    <div class="columns-6">
                        <div class="margin-bottom-3">
                            <div class="margin-bottom-1">
                                <label>{{ 'applicant-tracker.jobBoardTitle' | appTranslate }}</label>
                            </div>
                            <p>{{ jobBoard?.title || '' }}</p>
                        </div>
                        <div class="margin-bottom-3">
                            <div class="margin-bottom-1">
                                <label>{{ 'applicant-tracker.jobBoardAddress' | appTranslate }}</label>
                            </div>
                            <p>
                                <ng-container *ngIf="jobBoard?.companySlug">
                                    <a (click)="goToJobBoardAddress()">
                                        {{ jobBoardAddress }}
                                        <mat-icon class="margin-left-1" svgIcon="openInNew"></mat-icon>
                                    </a>
                                </ng-container>
                            </p>
                        </div>
                        <div>
                            <div class="margin-bottom-1">
                                <label>{{ 'applicant-tracker.embeddedJobBoard' | appTranslate }}</label>
                            </div>
                            <p>
                                <ng-container *ngIf="jobBoard?.companySlug">
                                    <ui-button type="primary" (click)="openEmbeddedJobBoard()">{{
                                        'applicant-tracker.getStarted' | appTranslate
                                    }}</ui-button>
                                </ng-container>
                            </p>
                        </div>
                    </div>
                    <div class="columns-6">
                        <div class="margin-bottom-3">
                            <div class="margin-bottom-1">
                                <label class="margin-bottom-1">{{
                                    'applicant-tracker.companyWebsite' | appTranslate
                                }}</label>
                            </div>
                            <p>{{ jobBoard?.companyUrl || '' }}</p>
                        </div>
                        <div>
                            <div class="margin-bottom-1">
                                <label>{{ 'applicant-tracker.successMessage' | appTranslate }}</label>
                            </div>
                            <p>{{ jobBoard?.successMessage || '' }}</p>
                        </div>
                    </div>
                </div>
            </ui-card>

            <ui-card *ngIf="hasAutomatedEmailSettings">
                <app-segment-header
                    *ngIf="!automatedEmailSettings"
                    title="{{ 'applicant-tracker.automaticEmailSettings' | appTranslate }}"
                    createLabel="setUp"
                    (create)="setUpAutomatedEmailSettings()"
                ></app-segment-header>

                <app-segment-header
                    *ngIf="automatedEmailSettings"
                    title="{{ 'applicant-tracker.automaticEmailSettings' | appTranslate }}"
                    (edit)="editAutomatedEmailSettings()"
                ></app-segment-header>

                <p>
                    {{
                        'applicant-tracker.setUpAnEmailThatWillAutoSendWhenApplicantsApplyToYourJobBoard' | appTranslate
                    }}
                </p>

                <div class="margin-top-4" *ngIf="automatedEmailSettings">
                    <p class="automated-email-settings-label">{{ 'applicant-tracker.from' | appTranslate }}</p>
                    <p>{{ automatedEmailSettings.replyTo }}</p>
                    <hr />
                    <p class="automated-email-settings-label">{{ 'applicant-tracker.subject' | appTranslate }}</p>
                    <p>{{ automatedEmailSettings.subject }}</p>
                    <hr />
                    <p class="automated-email-settings-label">{{ 'applicant-tracker.body' | appTranslate }}</p>
                    <div [innerHtml]="automatedEmailSettings.body | sanitizeHtml"></div>
                </div>
            </ui-card>

            <ui-card>
                <div class="ui">
                    <app-segment-header
                        title="{{ 'applicant-tracker.advancedStyles' | appTranslate }}"
                        (edit)="openEditAdvanceStyles()"
                        [allowEdit]="jobBoard?.companySlug"
                    ></app-segment-header>

                    <ui-banner variant="info" class="margin-bottom-3" *ngIf="hasResponsiveJobBoard">
                        <p>
                            {{
                                'applicant-tracker.addingCustomCssWillOverrideTheResponsivenessPleaseUseCautionWhen'
                                    | appTranslate
                            }}
                        </p>
                    </ui-banner>

                    <div class="field advanced-styles">
                        <label>{{ 'applicant-tracker.urlForCustomCss' | appTranslate }}</label>
                        <div class="ui advanced-styles">
                            {{ jobBoard?.customCssUrl || 'applicant-tracker.noUrlInUse' | appTranslate }}
                        </div>
                    </div>

                    <div class="field advanced-styles">
                        <label>{{ 'applicant-tracker.customCss' | appTranslate }}</label>
                        <div class="ui">
                            {{ jobBoard?.customCss || 'applicant-tracker.noCustomCssInUse' | appTranslate }}
                        </div>
                    </div>
                </div>
            </ui-card>
        </div>
        <div class="profile-layout-sidebar">
            <ui-card>
                <div class="ui">
                    <app-segment-header
                        title="{{ 'applicant-tracker.jobBoardTheme' | appTranslate }}"
                        (edit)="openEditBrandAssets()"
                    ></app-segment-header>
                    <div>
                        <p
                            [innerHTML]="
                                'applicant-tracker.theJobBoardThemeWillOnlyAffectTheJobBoardClick' | appTranslate
                            "
                        ></p>
                        <img class="ui centered image" *ngIf="jobBoard?.logoId" [src]="logoPath | secure" />
                        <div *ngIf="!jobBoard?.logoId" class="placeholder-image">
                            <span>{{ 'applicant-tracker.noLogoSet' | appTranslate }}</span>
                        </div>
                        <div class="app-grid job-board-color-container">
                            <div class="columns-6">
                                {{ 'applicant-tracker.buttonColor' | appTranslate }}
                                <div
                                    class="job-board-color-display"
                                    [style.background-color]="jobBoard?.buttonColor"
                                ></div>
                            </div>
                            <div class="columns-6">
                                {{ 'applicant-tracker.headerColor' | appTranslate }}
                                <div
                                    class="job-board-color-display"
                                    [style.background-color]="jobBoard?.pageColor"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </ui-card>
        </div>
    </div>
</div>
